<template>
  <gh-table-page v-model="selectedModels" ref="table" :show-tabs="true" :tabs="tabs" :args-query="argsQuery"
    :module="module" :cls="cls" :template-model="itemTemplate" @save-after="$refs.struNav.query()"
    @delete-after="$refs.struNav.query()" @@start-query="$refs.meterTypeNav.query()">
    <template #area_left>
      <structure-navigation ref="struNav" v-model="selectedStructure" @update:dataSource="invokeStatisticCount">
        <template #node-append="{node,data}">
          -<strong class="text--primary font-italic">{{getCount(data.Id)}}</strong>&nbsp<span> </span>
        </template>
      </structure-navigation>
    </template>

    <template #area_query>
      <v-layout row wrap align-center>
        <v-flex xs3>
          <v-text-field v-model="argsQuery.keywords" counter :autofocus="true" clearable label="关键字"
            append-icon="mdi-circle-edit-outline"></v-text-field>
        </v-flex>
        <v-flex xs8 offset-xs1>
          <meter-type-navigation ref="meterTypeNav" :stru-cd="StruCd" :keywords="argsQuery.keywords"
            @onSelected="onSelectedType"></meter-type-navigation>

        </v-flex>
      </v-layout>

    </template>
    <template #area_operation_before>
      <structure-selector v-if="selectedModels.length>0" btnText="调配" title="请选择结构" :after-submit="changeStructureTo">
      </structure-selector>
    </template>
    <!-- <template #table-cell-="{props}">
     <v-btn color="success">{{props.}}</v-btn>
    </template> -->
  </gh-table-page>



</template>

<style scoped>
</style>

<script>
  import Meter from "./meter.ts";
  export default Meter;
</script>